export enum UsersRoutes {
  index = 'users-index',
  home = 'users-home',
  view = 'users-view',
  create = 'users-create'
}
